import { useCallback, useMemo, useState } from 'react'
import { type TeamId } from '@terros/common'
import { type QuestionBreakdownExpandKey } from './breakdownTree'

export type QuestionBreakdownExpansion = {
  expandedKeys: Set<QuestionBreakdownExpandKey>
  expandedTeamIds: TeamId[]
  toggle: (key: QuestionBreakdownExpandKey) => void
  collapseAll: VoidFunction
}

export const toggleBreakdownKey = (
  expanded: Set<QuestionBreakdownExpandKey>,
  key: QuestionBreakdownExpandKey
): Set<QuestionBreakdownExpandKey> => {
  const next = new Set(expanded)
  if (!next.delete(key)) next.add(key)
  return next
}

export const useQuestionBreakdownExpansion = (): QuestionBreakdownExpansion => {
  const [expandedKeys, setExpandedKeys] = useState<Set<QuestionBreakdownExpandKey>>(new Set())

  const toggle = useCallback((key: QuestionBreakdownExpandKey) => {
    setExpandedKeys((current) => toggleBreakdownKey(current, key))
  }, [])
  const collapseAll = useCallback(() => setExpandedKeys(new Set()), [])
  const expandedTeamIds = useMemo((): TeamId[] => Array.from(expandedKeys), [expandedKeys])

  return { expandedKeys, expandedTeamIds, toggle, collapseAll }
}
